/**
 * Geolocation Modal Scroll Fix
 * Fixes scroll issues with Orbe Geolocation popup modal
 */

(function() {
  'use strict';

  // Specific selectors for the geolocation modal
  const MODAL_SELECTOR = '#md-app-embed__modal';
  const MODAL_CONTAINER_SELECTOR = '.md-modal__container';
  const MODAL_BACKDROP_SELECTOR = '.md-modal__backdrop';

  let isModalOpen = false;

  // MutationObserver to detect when geolocation modal is added to DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if this is the geolocation modal or contains it
          const modal = node.matches && node.matches(MODAL_SELECTOR)
            ? node
            : node.querySelector(MODAL_SELECTOR);

          if (modal) {
            handleModalOpen(modal);
          }
        }
      });

      mutation.removedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const modal = node.matches && node.matches(MODAL_SELECTOR)
            ? node
            : node.querySelector(MODAL_SELECTOR);

          if (modal && isModalOpen) {
            handleModalClose();
          }
        }
      });
    });
  });

  function handleModalOpen(modal) {
    if (isModalOpen) return; // Prevent duplicate calls
    isModalOpen = true;

    console.log('Geolocation modal detected, disabling scroll');

    // Calculate scrollbar width BEFORE hiding overflow
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Set CSS variable for scrollbar compensation
    document.documentElement.style.setProperty('--scrollBarWidth', scrollbarWidth + 'px');

    // Use existing disableScroll function if available
    if (typeof disableScroll === 'function') {
      disableScroll();
    } else {
      // Fallback: manually disable scroll
      document.body.classList.add('scrollLock');
      document.dispatchEvent(new CustomEvent('lenis:stop'));
    }

    // Fix select dropdown scrolling inside modal
    fixSelectScrolling(modal);

    // Add click listener to backdrop and close buttons
    setupCloseListeners(modal);
  }

  function handleModalClose() {
    if (!isModalOpen) return; // Prevent duplicate calls
    isModalOpen = false;

    console.log('Geolocation modal closed, enabling scroll');

    // Disconnect country list observer if it exists
    const modal = document.querySelector(MODAL_SELECTOR);
    if (modal && modal._countryListObserver) {
      modal._countryListObserver.disconnect();
      delete modal._countryListObserver;
    }

    // Reset CSS variable
    document.documentElement.style.setProperty('--scrollBarWidth', '0px');

    // Use existing enableScroll function if available
    if (typeof enableScroll === 'function') {
      enableScroll();
    } else {
      // Fallback: manually enable scroll
      document.body.classList.remove('scrollLock');
      document.dispatchEvent(new CustomEvent('lenis:start'));
    }
  }

  function setupCloseListeners(modal) {
    // Listen for clicks on backdrop
    const backdrop = modal.querySelector(MODAL_BACKDROP_SELECTOR);
    if (backdrop) {
      backdrop.addEventListener('click', () => {
        handleModalClose();
      }, { once: true });
    }

    // Listen for close button clicks
    const closeButtons = modal.querySelectorAll('[class*="close"], [aria-label*="close" i], [aria-label*="닫기"]');
    closeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        handleModalClose();
      }, { once: true });
    });
  }

  function fixSelectScrolling(modal) {
    // Fix Orbe country list dropdown specifically
    const orbeCountryList = document.querySelector('#orbeCountryList');
    if (orbeCountryList) {
      orbeCountryList.setAttribute('data-lenis-prevent', '');
      orbeCountryList.setAttribute('data-lenis-prevent-wheel', '');
      orbeCountryList.setAttribute('data-lenis-prevent-touch', '');
      console.log('Fixed #orbeCountryList scrolling');
    }

    // Find all custom select buttons in the modal
    const selectButtons = modal.querySelectorAll('button[aria-haspopup="listbox"], button[class*="select"]');
    selectButtons.forEach(button => {
      button.setAttribute('data-lenis-prevent', '');
    });

    // Find all select elements (if any native ones exist)
    const selects = modal.querySelectorAll('select');
    selects.forEach(select => {
      select.setAttribute('data-lenis-prevent', '');
    });

    // Handle any custom dropdown menus (not native select)
    const dropdowns = modal.querySelectorAll('[role="listbox"], [role="combobox"], ul[class*="list"], div[class*="options"]');
    dropdowns.forEach(dropdown => {
      dropdown.setAttribute('data-lenis-prevent', '');
      dropdown.setAttribute('data-lenis-prevent-wheel', '');
      dropdown.setAttribute('data-lenis-prevent-touch', '');
    });

    // Also watch for dynamically added country list
    const observer = new MutationObserver(() => {
      const countryList = document.querySelector('#orbeCountryList');
      if (countryList && !countryList.hasAttribute('data-lenis-prevent')) {
        countryList.setAttribute('data-lenis-prevent', '');
        countryList.setAttribute('data-lenis-prevent-wheel', '');
        countryList.setAttribute('data-lenis-prevent-touch', '');
        console.log('Fixed dynamically added #orbeCountryList');
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Store observer to disconnect later if needed
    modal._countryListObserver = observer;
  }

  // Start observing when DOM is ready
  function init() {
    // Check if modal already exists in DOM
    const existingModal = document.querySelector(MODAL_SELECTOR);
    if (existingModal && existingModal.offsetParent !== null) {
      handleModalOpen(existingModal);
    }

    // Start observing for future modals
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Also setup style observer for existing modal
    setupStyleObserver();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Listen for visibility changes (in case modal uses display/visibility)
  function setupStyleObserver() {
    const styleObserver = new MutationObserver(() => {
      const modal = document.querySelector(MODAL_SELECTOR);
      if (modal) {
        const isVisible = modal.offsetParent !== null &&
                         (modal.style.display !== 'none') &&
                         (!modal.style.visibility || modal.style.visibility !== 'hidden');

        if (isVisible && !isModalOpen) {
          handleModalOpen(modal);
        } else if (!isVisible && isModalOpen) {
          handleModalClose();
        }
      } else if (isModalOpen) {
        // Modal was removed from DOM
        handleModalClose();
      }
    });

    // Observe the entire body for modal changes
    styleObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      childList: true,
      subtree: true
    });
  }

})();
